import { createFileRoute } from '@tanstack/react-router'

import DetailAnggotaPoktanPage from '@/components/pages/backoffice/_klb-petani/_poktan/_$poktanId/_anggota/_$anggotaPoktanId/containers/DetailAnggotaPoktanPage'

export const Route = createFileRoute(
  '/_backoffice/klb-petani/poktan/$poktanId/anggota/$anggotaPoktanId/'
)({
  component: DetailAnggotaPoktanPage
})
